import {create} from "zustand/react";

interface CompareState {
    ids: number[];
    addToCompare: (id: number) => void;
    removeFromCompare: (id: number) => void;
    clearCompare: () => void;
    setIds: (ids: number[]) => void; // Added this
    isFull: () => boolean;
}

export const useCompareStore = create<CompareState>((set, get) => ({
    ids: (() => {
        const saved = localStorage.getItem('compare-ids');
        return saved ? saved.split(',').map(Number).filter(n => !!n) : [];
    })(),

    addToCompare: (id) => set((state) => {
        if (state.ids.includes(id) || state.ids.length >= 5) return state;
        const updated = [...state.ids, id];
        localStorage.setItem('compare-ids', updated.join(','));
        return { ids: updated };
    }),

    removeFromCompare: (id) => set((state) => {
        const updated = state.ids.filter(dId => dId !== id);
        localStorage.setItem('compare-ids', updated.join(','));
        return { ids: updated };
    }),

    clearCompare: () => {
        localStorage.removeItem('compare-ids');
        set({ ids: [] });
    },

    setIds: (newIds) => {
        localStorage.setItem('compare-ids', newIds.join(','));
        set({ ids: newIds });
    },

    isFull: () => get().ids.length >= 4,
}));